module.exports = __webpack_public_path__ + "media/neworder.ff3a63f4.ff3a63f4.mp3";